import { useState, useEffect } from 'react';
import { ImageUploadScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/general/ImageUploadScadaIcon';
import { AssetWrapper } from '../../assetComponents/assetWrapper/AssetWrapper';
import { BaseAssetProps } from '../../assetComponents/types';
import { Box, useTheme } from '@mui/material';

type Props = BaseAssetProps;

export const ImageUpload = ({ selected, width, height, data, id }: Props) => {
  const [dimensions, setDimensions] = useState({
    width: data?.width ?? width ?? 100,
    height: data?.height ?? height ?? 100,
  });
  useEffect(() => {
    if (data?.width || data?.height) {
      setDimensions({
        width: data.width ? Number(data.width) : dimensions.width,
        height: data.height ? Number(data.height) : dimensions.height,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.width, data?.height]);

  useEffect(() => {
    if (width || height) {
      setDimensions({
        width: width ?? dimensions.width,
        height: height ?? dimensions.height,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, height]);
  const theme = useTheme();
  return (
    <AssetWrapper selected={selected} width={dimensions.width} height={dimensions.height} id={id}>
      {data?.url || data?.previewUrl ? (
        <img
          src={data.url || data.previewUrl}
          alt={data.name}
          style={{ width: dimensions.width, height: dimensions.height }}
        />
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: dimensions.width,
            height: dimensions.height,
            border: `1px dotted ${theme.palette.grey[600]}`,
          }}
        >
          <ImageUploadScadaIcon />
        </Box>
      )}
    </AssetWrapper>
  );
};
